module.exports = __webpack_public_path__ + "media/site/images/banners/banner-contact-mobile-42ab21b7e601034a77d578ced4850042.png";